'use strict';
var $ = require('jquery');

// Constructor
var Alert = function() {
    $('.alert a.close').on('click touchstart', function () {
        $(this).parent().remove();
    });
};

module.exports = Alert;
